import React from 'react';
import PropTypes from 'prop-types';
import Image from '../Image';
import './styles.css';

export default function Logo({ src, alt }) {
  return (
    <div className="logo-container">
      <Image src={src} size="tiny" alt={alt} />
    </div>
  );
}

Logo.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
};
